import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=0d77f260"
import script from "./ImportFile.vue?vue&type=script&lang=js"
export * from "./ImportFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports